// imgix rendering api https://docs.imgix.com/apis/rendering

import React from 'react'

import clsx from 'clsx'

import fallbackImg from 'assets/images/fallback-img.png'

const imginxDomain = 'gdm-catalog-fmapi-prod.imgix.net'

/** @type {import("./types").default} */
const FixedImage = ({ className, fetchWidth, fetchHeight, src, alt, quality = 50, ...props }) => {
  const finalWidth = fetchWidth || props.width
  const finalHeight = fetchHeight || props.height

  if (!src) return <img className={clsx('Image')} alt={alt} src={fallbackImg.src} width={40} height={40} {...props} />

  let finalUrl = src
  if (typeof src === 'object') {
    finalUrl = src.src || ''
  }

  if (finalUrl?.includes(imginxDomain)) {
    const url = new URL(finalUrl)

    if (finalWidth) {
      url.searchParams.set('w', `${finalWidth}`)
    }

    if (finalHeight) {
      url.searchParams.set('h', `${finalHeight}`)
    }

    url.searchParams.set('q', `${quality}`)

    finalUrl = url.toString()
  }

  return <img className={clsx('Image', className)} alt={alt} src={finalUrl} {...props} />
}

export default FixedImage
